import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../Firebase/Firebase';
import { doc, getDoc } from 'firebase/firestore';
import './search.css';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';

function Resultados() {
    const location = useLocation();
    const { ciudad, sector, tipoEspacio, espaciosIds } = location.state || {};
    const [espaciosData, setEspaciosData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [currentSlide, setCurrentSlide] = useState(0); // Estado para el slider
    const navigate = useNavigate();

    // Cargar los datos de los espacios
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const espaciosArray = [];

                for (const id of espaciosIds) {
                    const docRef = doc(db, 'espacios', id);
                    const docSnap = await getDoc(docRef);

                    if (docSnap.exists()) {
                        espaciosArray.push(docSnap.data());
                    } else {
                        console.log(`No existe documento con ID: ${id}`);
                    }
                }
                setEspaciosData(espaciosArray);
            } catch (err) {
                setError('Error al cargar los datos');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        if (espaciosIds && espaciosIds.length > 0) {
            fetchData();
        } else {
            setLoading(false);
        }
    }, [espaciosIds]);

    // Manejar botón de reservar
    const handleReservar = (idEspacio) => {
        navigate(`/office/${idEspacio}`);
    };

    // Función para ir al siguiente espacio
    const nextSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex + 1) % espaciosData.length);
    };

    // Función para ir al espacio anterior
    const prevSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex - 1 + espaciosData.length) % espaciosData.length);
    };

    if (loading) {
        return <div>Cargando...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            <Navbar />
            <br/>
            <br/>
            <div className="resultados-container" style={{ marginTop: '50px' }}>
                <h1>Espacios en la ciudad de {ciudad}, sector {sector}, tipo de espacio {tipoEspacio}</h1>

                <div className="espacios-slider">
                    {/* Botón para retroceder */}
                    <button className="prev-btn-tp-es" onClick={prevSlide}>❮</button>

                    {/* Mostrar el espacio actual basado en el índice del slider */}
                    {espaciosData.length > 0 && (
                        <div key={espaciosData[currentSlide]?.IdEspacio} className="espacio-card">
                            {espaciosData[currentSlide]?.Imagenes && espaciosData[currentSlide]?.Imagenes[0] && (
                                <img
                                    src={espaciosData[currentSlide].Imagenes[0]}
                                    alt={espaciosData[currentSlide].NombreEspacio}
                                />
                            )}
                            <h3>{espaciosData[currentSlide]?.NombreEspacio}</h3>
                            <button
                                onClick={() => handleReservar(espaciosData[currentSlide]?.IdEspacio)}
                                className="reservar-btn"
                            >
                                Confirmar Reserva
                            </button>
                            <h4>Espacio {currentSlide + 1} de {espaciosData.length}</h4>
                        </div>
                    )}

                    {/* Botón para avanzar */}
                    <button className="next-btn-tp-es" onClick={nextSlide}>❯</button>
                </div>
            </div>
        </div>
    );
}

export default Resultados;
